import { render, staticRenderFns } from "./SummaryRoutes.vue?vue&type=template&id=52d43f6c&"
import script from "./SummaryRoutes.vue?vue&type=script&lang=js&"
export * from "./SummaryRoutes.vue?vue&type=script&lang=js&"
import style0 from "./SummaryRoutes.vue?vue&type=style&index=0&id=52d43f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports